<!--  -->
<template>
  <div class='handMonitorRrported'>
    <v-header id='header' v-if='$route.query.source==0' @back='handleShowBack' :rightTitle='rightTitle' v-on:rightClick='rightClick' :headTitle='headTitle' :goApp='true' :isBack='true' :pageName="pageName"></v-header>
    <div class="container" id='container'>
      <div class="banner">
        <img :src="bannerImg" alt="" >
      </div>
      <div class="tab-content">
        <van-tabs v-model="tabIndex" :offset-top="utils.isIphoneX()&&$route.query.source==0?85:$route.query.source==0?65:0" scrollspy sticky color='#26B4FF' :ellipsis="false" title-active-color='#26B4FF' title-inactive-color='#333' @scroll='handleScroll' @change='handleChangeTab' >
          <van-tab title="介绍" title-style='font-size:16px;'>
            <div class="introduce" id='introduce'>
              <div class="video-box" @click='jumpToVideo' v-if="vedioUrl">
                <video v-if='vedioUrl' crossorigin="anonymous" :poster='vedioPicUrl' id='videoPlay' x5-video-player-type='h5-page' controlslist="nodownload" :src="vedioUrl" controls ></video>
                <img v-else :src="vedioPicUrl" alt="">
                <p>（调查方案解读）</p>
              </div>
              <div class="activity-background">
                <div class="item-title df-item-center">
                  活动背景
                </div>
                <div class="item-content">
                  <div class="content-title"> 主办方: </div>
                  <p>{{sponsor}}</p>
                </div>
                <div class="item-content">
                  <div class="content-title"> 目的： </div>
                  <p>每隔两年进行1次，目的是了解医务人员手卫生现状及有关医院感染指标，评价手卫生与医院感染相关指标的关系，进一步促进手卫生措施的落实。</p>
                </div>
                <div class="notice-file df-center" @click='goPdfPreview' v-if="noticeUrl">
                  <span>点击查看官方通知文件</span>
                  <img
                    src="../../assets/images/report-arrowRight.png"
                    alt=""
                  >
                </div>
              </div>
              <div class="earnings">
                <div class="item-title df-item-center">
                  可获收益
                </div>
                <div class="earnings-heed">
                  <div class='df-center'>
                    <img
                      src="../../assets/images/report-tisheng.png"
                      alt=""
                    >
                    <h3>获得专业提升</h3>
                  </div>
                  <p>规范感控专兼职人员手卫生监测方法，促进本院医务人员手卫生依从率、正确率、知晓率提升</p>
                </div>
                <div class="earnings-content df-between">
                  <div
                    class='earnings-left'
                    style='margin-right:10px'
                  >
                    <h3 style='margin-bottom:10px;'>免费学习</h3>
                    <p>中国医务人员诊疗过程手卫生执行示范情景剧系列</p>
                  </div>
                  <div class='earnings-right'>
                    <img
                      src="../../assets/images/mfxx.png"
                      alt=""
                    >
                  </div>
                </div>

                <div class="earnings-content df-between">
                  <div
                    class='earnings-right'
                    style='margin-right:10px'
                  >
                    <img
                      src="../../assets/images/zngc.png"
                      alt=""
                    >
                  </div>
                  <div class='earnings-left'>
                    <h3 style='margin-bottom:10px;text-align:right;'>智能观察</h3>
                    <p class='p-right'>利用手机等移动设备即可录入观察数据/上传现场拍照/记录问题等实现移动智能查检在线</p>
                  </div>
                </div>

                <div
                  class="earnings-content df-between"
                  style='margin-bottom:20px;'
                >
                  <div
                    class='earnings-left'
                    style='margin-right:10px'
                  >
                    <h3 style='margin-bottom:10px;'>授权证书</h3>
                    <p>完成学习并考试合格，可获得电子证书“医疗机构医务人员诊疗过程手卫生调查知识与技能合格证”</p>
                  </div>
                  <div class='earnings-right'>
                    <img
                      :src="certificateImg"
                      alt=""
                    >
                  </div>
                </div>
                <div class="earnings-heed">
                  <div class='df-center'>
                    <img
                      src="../../assets/images/repotr-tongji.png"
                      alt=""
                    >
                    <h3>获得专业报告</h3>
                  </div>
                  <p>可自动获得本次调查的各类数据统计</p>
                </div>
                <ul class='list-content'>
                  <li class='df-item-center'>全员手卫生知识知晓率情况</li>
                  <li class='df-item-center'>调查科室手卫生依从及正确情况</li>
                  <li class='df-item-center'>调查科室手卫生用品消耗情况</li>
                  <li class='df-item-center'>重点质控指标情况</li>
                </ul>
              </div>
              <div class="data-safety">
                <div class="item-title df-item-center">
                  数据安全
                </div>
                <div class="data-safety-content">
                  <p style='margin-bottom:20px;'>医疗机构上报的数据在评定有效之后将会纳入全国统计分析样本，分析统计数据趋势，不会关注及披露医疗机构个体数据，保持数据真实有效即可。</p>
                  <p>同时，本次上报技术和服务由获得“国家信息安全三级等保认证”（由公安部颁发，非银行机构最高安全认证）的感控工作间支持，保证数据安全。</p>
                </div>
              </div>
            </div>
          </van-tab>
          <van-tab title="流程" title-style='font-size:16px;'>
            <div class="item-title item-title1 df-item-center">
              流程
            </div>
            <div class="tab-flow" id='tabFlow'>
              <div class="template-download df-center" v-if='$route.query.source==0&&templateDownloadUrl'>
                <span>院内调查工作方案模版</span>
                <span class='download' @click='handleDownTemplate'>下载</span>
              </div>
              <div class="flow-item" v-for='(item,index) in listData' :key='index' >
                <div class="flow-title df-item-center">
                  <span class='df-center'>{{index+1}}</span>
                  <h3>{{item.linkName}}</h3>
                </div>
                <div class="flow-content-box">
                  <div class='flow-content'>
                    <div :class="{'flow-content-item-time':index<3}" style='display:flex;' >
                      <img src="../../assets/images/report-shijin.png" alt="" >
                      <p>{{item.describes}}</p>
                    </div>
                    <div class='flow-content-item' v-for='(d,idx) in item.children' :key='idx'>
                      <div class='dot'></div>
                      <p>{{d.indexName}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </van-tab>
          <van-tab title="推荐" title-style='font-size:16px;'>
            <div class="item-title item-title1 df-item-center">
              推荐
            </div>
            <div class="recommend" id='recommend' @click='handleToKnowledgeMeasurement'>
              <!-- <img src="../../assets/images/tuijian-img1.png" alt="" > -->
              <img src="../../assets/images/hand-bg-edit.png" alt="" >
            </div>
          </van-tab>
        </van-tabs>
      </div>

      <van-popup v-model="isShowPopup" style='border-radius:10px;'>
        <div class="dalog-box">
          <div class="dalog-content">
            <div class="dalog-title">{{dalogTitle}}</div>
            <p :style="{'text-align':$route.query.source==0?'':'center'}">{{dalogContent}}</p>
          </div>
          <div class="line"></div>
          <div class="btn-box df-between">
            <div class="btn btn-gray df-center" @click='handleBtnLeft' >{{dalogBtn1}}</div>
            <div class="btn df-center" @click='handleBtnRight' >{{dalogBtn2}}</div>
          </div>
          <div class="close-dalog" @click='handleClosePopup' >
            <i class="iconfont icon-close"></i>
          </div>
        </div>
      </van-popup>
      <van-popup v-model="isShowNotAuthPopup" style='border-radius:10px;'>
        <div class="dalog-box">
          <div class="dalog-content">
            <div class="dalog-title">权限提示</div>
            <p>抱歉，您没有开通区域管理员权限，如果您是区域负责人，请与主办方联系申请开通：曾翠  0731-89753264</p>
          </div>
          <div class="line"></div>
          <div class="btn-box df-between">
            <div class="btn df-center" @click='handleShowNotAuthPopup'>知道了</div>
          </div>
        </div>
      </van-popup>

      <van-popup v-model="isShowRoleSelect" style='border-radius:10px;'>
          <roleSelect :postId='_userInfo.data&&_userInfo.data.postId?_userInfo.data.postId : ""' :userPost='userPost' v-on:conFirmRole='conFirmRole'></roleSelect>
      </van-popup>
    </div>
    <div class="footer df-between" v-if="!isLoading&&isManagerUser == 1">
      <div
        class="btn df-center progressAndStatistics"
        @click='checkProgress'
      >
        区域上报进度及统计
      </div>
      <div
        class="btn df-center join-reported"
        @click='handleJoinReported'
      >进入上报</div>
    </div>
    <div class="footer df-between" style="padding:0px 20px 30px" v-if="!isLoading&&!isManagerUser">
      <div
        class="btn df-center join-reported"
        style="height:44px;margin-left:0px;"
        @click='handleJoinReported'
      >进入上报</div>
    </div>

  </div>
</template>

<script>
  import axios from 'axios'
  import header from '../../components/header/header'
  import Vue from 'vue'
  import {mapState,mapActions} from 'vuex'
  import roleSelect from './roleSelect.vue'
  import { Toast } from 'vant'
  import _store from '../../store/index'

  Vue.use(Toast)
  export default {
    data() {
      return {
        indexTypeList:[],
        knowledgePath:'',
        isLoading:true, // 点击事件需要的参数是否拿到
        swiftRoleAbility:'', // 0表示设置了不允许修改1表示可以修改
        taskBeginTime:'',
        taskState:false,
        sponsor:'',
        userPost:'', //  手卫生角色 1 手卫生观察员  2其他数据监测员  3其他医务人员
        isFixed:false, // 是否吸顶
        isManagerUser:'', // 1 管理员权限
        isAuth:'', // 7 未激活 6 修改后待审核 5被邀请 4 使用中 3 审核拒绝 2 已提交认证，待审核 1 审核通过 0已激活，未提交审核
        noticeUrl:'',
        vedioPicUrl:"",
        templateDownloadUrl:"",
        coverUrl:'',
        vedioUrl:"",
        isShowPopup: false,
        isShowNotAuthPopup:false,
        isShowRoleSelect:false,
        headTitle: '',
        rightTitle:"分享",
        pageName: 'handMonitorRrported',
        tabIndex: 0,
        dalogTitle: '',
        dalogContent: '',
        dalogBtn1: '',
        dalogBtn2: '',
        userStatusTips: [
          {
            dalogTitle: '您当前处在体验医院',
            dalogContent: '请先前往我的医院加入到正确的医院后在进行相应操作',
            dalogBtn1: '',
            dalogBtn2: '去加入医院',
          },
          {
            dalogTitle: '审核认证中',
            dalogContent:
              '您的认证资料已提交，待管理员XXX审核，如有问题，可拨打平台电话400-969-7756',
            dalogBtn1: '重新编辑',
            dalogBtn2: '通知管理员',
          },
          {
            dalogTitle: '审核认证中',
            dalogContent:
              '您已申请加入【XX医院】，资料正在审核中，请联系客服尽快处理',
            dalogBtn1: '修改资料',
            dalogBtn2: '联系客服',
          },
          {
            dalogTitle: '提示',
            dalogContent: '需登录【感控工作间APP】操作',
            dalogBtn1: '取消',
            dalogBtn2: '打开APP',
          },
        ],
        listData:[]
      }
    },
    components: {
      'v-header': header,
      roleSelect
    },
    computed: {
      ...mapState({
        _userInfo: (state) => state.InvestorInfo,
        baseUrl: (state) => state._base,
        _studyExamBase:  (state) => state._studyExamBase,
        _headerToken: (state) => state.header
      }),
      currentUserId () {
        return this.$route.query.userId ? this.$route.query.userId : this._userInfo.data.userId
      },
      currentComId () {
        return this.$route.query.comId ? this.$route.query.comId : this._userInfo.data.comId
      },
      handleBeginTime () {
       return this.taskBeginTime.substring(0,4)+'年'+this.taskBeginTime.substring(5,7)+'月'+this.taskBeginTime.substring(8,10)+'日'+this.taskBeginTime.substring(11,13)+'时'+this.taskBeginTime.substring(14,16)+'分'
      },
      bannerImg () {
        return require(`../../assets/images/fixed-banner${this.$route.query.batch || ''}.png`)
      },
      certificateImg () {
        return require(`../../assets/images/sqzs${this.$route.query.batch || ''}.png`)
      }
    },
    created() {
      this.taskState = sessionStorage.getItem('taskState')
    },
    mounted(){
      axios({
        method: 'get',
        // baseURL: this.baseUrl.indexOf('dygk')!=-1 ? 'https://education.gkgzj.com' : this.baseUrl,
        url:'date/openDate.json',
      }).then((res)=>{
        this.templateDownloadUrl = res.data.templateDownloadUrl
        localStorage.setItem('dateObj',JSON.stringify(res.data))
      })
      // setTimeout(()=>{
      //   this.findvideocover()
      // },1000)
      if (this.$route.query.source == 0) {
        setTimeout(() => {
          if(!this._headerToken.headers['x-userkey']){
            console.log('重新获取信息');
            this.getAccessToken()
          } else {
            console.log('app内来了');
            this.__initPage()
          }
        }, 600);
      } else {
        console.log('分享的链接');
        this._headerToken.headers['x-userkey'] = this.$route.query.token
        this.__initPage() // 链接中带的token账号重新登录后接口提示重新登录，需后台配合
      }
    },
    watch:{
      _userInfo(newV,oldV) {
        console.log(newV,'newV');
        if(newV !== oldV) {
          this.__initPage()
        }
      }
    },
    beforeRouteEnter(to,from,next){
      if(to.query.direct == 'studyExam') {
         let path = `${_store.state._studyExamBase}/manager-intf/?#/knowledgeMeasurement?source=0&direct=studyExam&sceneId=${to.query.sceneId}&title=${encodeURIComponent(to.query.title)}&finishPerson=${to.query.finishPerson}&taskId=${to.query.taskId}&batch=${to.query.batch}`;  
        //  let tempUrl = encodeURI(path);
        //  let encodeUrl = encodeURI(tempUrl) // 多次转码解决ios中文字符导致页面空白
         window.location.href = path + (this._userInfo.data.uniHm == '1' ? '&uniHm=1' : '')
      } else {
        next()
      }
    },
    methods: {
      ...mapActions(["getAccessToken"]),
      findvideocover() {
        // 获取video节点
        const video = document.getElementById("videoPlay");
        console.log(video,'videoDom');
        video.width = video.offsetWidth
        video.height = video.offsetHeight
        video.currentTime = 1 // 第一帧
        //创建canvas对象
        const canvas = document.createElement("canvas")
        canvas.width = video.offsetWidth
        canvas.height = video.offsetHeight
        this.$nextTick(()=>{
          // 利用canvas对象方法绘图
          canvas.getContext("2d").drawImage(video, 0, 0, canvas.width, canvas.height);
          // 转换成base64形式
          this.coverUrl  = canvas.toDataURL("image/jpeg") // 这个就是图片的base64
        })
      },
      __initPage() {
        localStorage.setItem('taskId',this.$route.query.taskId)
        localStorage.setItem('batch',this.$route.query.batch)
        console.log(this.currentUserId,'currentUserId');
        console.log(this.currentComId,'currentComId');
        this.initData()
        this.handleInit()
      },
      handleInit(){
        Promise.all([
          this.$http.getTaskDetailById({
            userId: this.currentUserId,
            sub_id: '',
            comId: this.currentComId,
            data: {
              taskId: this.$route.query.taskId,
            },
            malVersion: 'A0',
          }).then((res) => {
            if (res.code === 0) {
              this.taskBeginTime = res.data.taskBeginTime
              this.taskState = res.data.taskState
              this.sponsor = res.data.hospName
              this.headTitle = res.data.taskName
              this.noticeUrl = res.data.notices
              this.vedioPicUrl = res.data.vedioPicUrl
              // this.templateDownloadUrl = res.data.templateDownloadUrl
              this.vedioUrl = res.data.vedioUrl
              localStorage.setItem('taskName',res.data.taskName)
              sessionStorage.setItem('taskState',this.taskState)
              document.title = this.headTitle
            } else {
              this.$toast(res.msg)
            }
          }),
          this.$http.getUserHandActivityInfo({
            userId: this.currentUserId,
            sub_id: "",
            comId: this.currentComId,
            data: {
              comId: this.currentComId,
              userId: this.currentUserId,
              handTaskId: this.$route.query.taskId
            },
            malVersion: "A0"
          }).then((res) => {
              if (res.code === 0) {
                this.isManagerUser = res.data.isManagerUser
                this.isAuth = res.data.isAuth
                this.userPost = res.data.userPost
                this.swiftRoleAbility = res.data.swiftRoleAbility
                localStorage.setItem('isManagerUser',this.isManagerUser)
                localStorage.setItem('isAuth',this.isAuth)
                localStorage.setItem('handComplianceTarget',res.data.reportTarget.handComplianceTarget)
                localStorage.setItem('handCorrectionTarget',res.data.reportTarget.handCorrectionTarget)
                if(res.data.hasInit == 0){
                  this.initActivityData()
                }
              } else {
                this.$toast(res.msg);
              }
            })
        ]).then((res) => {
          this.isLoading = false
        })
      },
      rightClick(){
        let url = `${this.baseUrl}/handMonitorReported/#/handMonitorRrported?taskId=${this.$route.query.taskId}&batch=${this.$route.query.batch}&userId=${this._userInfo.data.userId}&comId=${this._userInfo.data.comId}&token=${this._userInfo.token}`
        let title =`邀请您参与${this.$route.query.batch}年全国医务人员诊疗过程手卫生调查`
        let content = '点击了解详情'
        console.log(url,'分享的url');
        try {
          uni.postMessage({
            data: {
              action: 'showShareView',
              data: {
                shareUrl: url,
                shareTitle: title,
                shareContent: content,
              }
            }
          });
          window.webkit.messageHandlers.showShareView.postMessage({
            shareUrl: url,
            shareTitle: title,
            shareContent: content,
          })
        } catch (err) {
          window.gk.showShareView(url, title, content)
        }
      },
      initData() {
        let params = {
          userId: this.currentUserId,
          sub_id: '',
          comId: this.currentComId,
          data: {
            taskId: this.$route.query.taskId,
          },
          malVersion: 'A0',
        }
        this.$http.getReportingTaskLinkInfo(params).then((res) => {
          if (res.code === 0) {
            this.listData = res.data
            let stepThreeBeginTime = res.data[2].beginTime.substring(0,4)+'年'+res.data[2].beginTime.substring(5,7)+'月'+res.data[2].beginTime.substring(8,10)+'日'
            this.listData.forEach((v, i) => {
              this.$set(v, 'isShowContent', false)
              this.$set(v, 'children', [])
              this.initChildRenData(v,i)
            })
            this.listData.push({
              linkName:"最后由感控科主任审核后确定上报",
              describes:stepThreeBeginTime+'之后'
            })
          } else {
            this.$toast(res.msg)
          }
        })
      },
      initChildRenData(val,index) {
        let params = {
          userId: this.currentUserId,
          sub_id: '',
          comId: this.currentComId,
          data: {
            taskLinkId: val.id,
            batch: this.$route.query.batch,
          },
          malVersion: 'A0',
        }
        this.$http.getReportingTaskIndex(params).then((res) => {
          if (res.code === 0) {
            res.data.forEach((v,i)=>{
              if(index==1){
                v.indexName = '完成'+v.indexName
              }else if(index==2){
                v.indexName = '提交'+v.indexName
                this.indexTypeList.push(v.indexType)
                localStorage.setItem('indexTypeList',this.indexTypeList)
              }
              if (v.indexType == '4') {
                this.knowledgePath = v.path
              }
            })
            val.children = res.data
          }
        })
        // console.log(this.listData,'listData');
      },
      // 点击开始上报初始化数据(永远只调一次)
      initActivityData(){
        let params = {
          userId: this.currentUserId,
          sub_id: "",
          comId: this.currentComId,
          data: {
            comId: this.currentComId,
            userId: this.currentUserId,
            taskId: this.$route.query.taskId
          },
          malVersion: "A0"
        };
        this.$http.initActivityData(params).then((res) => {
          if (res.code === 0) {
          } else {
            this.$toast(res.msg);
          }
        });
      },
      // 下载模板
      handleDownTemplate(){
        try {
          uni.postMessage({
            data: {
              action: 'downLoad',
              data: {
                url:
                  this.templateDownloadUrl,
                reportId: '',
                rptTitleAlias: '院内调查工作方案模版',
                isDesensitization: '',
              }
            }
          });
          window.webkit.messageHandlers.downLoad.postMessage({
            url:
              this.templateDownloadUrl,
            reportId: '',
            rptTitleAlias: '院内调查工作方案模版',
            isDesensitization: '',
          })
        } catch (err) {
          window.gk.downLoad(
            this.templateDownloadUrl,
            '',
            '院内调查工作方案模版'
          )
        }
      },
      jumpToVideo(){
        if(this.vedioUrl){
          window.location.href = this.vedioUrl
        }
      },
      // 查看通知文件
      goPdfPreview(){
        this.$router.push({
          path: "/pdfPreview",
          query: {
            url: this.noticeUrl,
            isShowPdfHead:'1',
            source:this.$route.query.source
          },
        });
      },
      handleShowBack(){
        this.utils.goAppBack()
      },
      handleScroll(val){
        this.isFixed = val.isFixed
      },
      handleChangeTab(){
        // let a = document.getElementById('introduce')
        // let b = document.getElementById('tabFlow')
        // if(this.tabIndex==2){
        //   a.style.display = 'none'
        //   b.style.display = 'none'
        //   // window.scrollTo(-100,-500);
        //   // document.getElementById('container').scrollTop = 200
        // }else{
        //   a.style.display = 'block'
        //   b.style.display = 'block'
        // }
      },
      handleClosePopup() {
        this.isShowPopup = false
      },
      // 知道了
      handleShowNotAuthPopup(){
        this.isShowNotAuthPopup = false
      },
      // 区域上报进度及统计
      checkProgress() {
        if(this.isLoading){
          return
        }
        if(this.taskState!=1&&this.taskState!=2){ // taskState: 0未开始1进行中2.已结束3.时间内容不完整
          Toast(`还未开始，将在${this.handleBeginTime}开放手卫生调查`)
          return
        }
        if(this.isManagerUser!=1&&this.$route.query.source == 0){
          this.isShowNotAuthPopup = true
          return
        }
        if (this.$route.query.source == 0) {
          // 跳转到上报进度及统计页
          this.$router.push({
            path: "/areaRptIndexParent"
          });
        }else{
          this.handleJump()
        }
      },
      handleJump(){
        this.dalogTitle = this.userStatusTips[3].dalogTitle
        this.dalogContent = this.userStatusTips[3].dalogContent
        this.dalogBtn1 = this.userStatusTips[3].dalogBtn1
        this.dalogBtn2 = this.userStatusTips[3].dalogBtn2
        this.isShowPopup = true
      },
      // 进入上报
      handleJoinReported() {
        if(this.isLoading){
          return
        }  
        if(this.taskState!=1&&this.taskState!=2){ // taskState: 0未开始1进行中2.已结束3.时间内容不完整
          Toast(`还未开始，将在${this.handleBeginTime}开放手卫生调查`)
          return
        }
        console.log(this.userPost,'this.userPost');
        if (this.$route.query.source == 0) {
          // this.isShowRoleSelect = true // 本地调试放开
          // return
          let _this = this
          console.log('在app内')
          try {
            window.jumpToMonitorRptIndex = function (data) {
              if(_this._userInfo.data.postId==1||_this._userInfo.data.postId==2){
                // if(_this.userPost&&_this.userPost!='3'){
                if(_this.userPost){
                  let flag = true
                  let index = ''
                  let isDel = false
                  let arr = _this.userPost.split(',')
                  arr.forEach((v,i)=>{
                    if(v == '3'){
                      index = i
                      isDel = true
                    }
                    if(v == '2'){
                      flag = false
                    }
                  })
                  if(isDel){
                    arr.splice(index,1) // 感控科主任或者专职不能存在其他医务人员的角色
                  }
                  if(flag){
                    arr.push('2') // 给感控科主任和专职默认手卫生观察员的角色
                  }
                  console.log(arr,'第一个');
                  localStorage.setItem('roleCode',arr)
                  _this.$router.push({
                    path: "/monitorRptIndexParent"
                  });
                }else{
                  if(_this.swiftRoleAbility == '0'){ //不允许修改执行角色(首次进入上报页面的用户不弹窗，默认为手卫生观察员之外的其他执行角色)
                    let arr = ['2']
                    localStorage.setItem('roleCode',arr)
                    _this.$router.push({
                      path: "/monitorRptIndexParent"
                    });
                    return
                  }
                  _this.isShowRoleSelect = true
                }
              }else if(_this._userInfo.data.postId==4){ // 角色为其他
                let arr = ['3']
                localStorage.setItem('roleCode',arr)
                  _this.$router.push({
                    path: "/monitorRptIndexParent"
                });
              }else{
                // if(_this.userPost&&_this.userPost!='2'){
                if(_this.userPost){
                  let arr = _this.userPost.split(',')
                  arr.forEach((v,i)=>{
                    if(v=='2'){
                      arr.splice(i,1) // 兼职不能存在其他数据监测员的角色
                    }
                  })
                  console.log(arr,'第二个');
                  localStorage.setItem('roleCode',arr)
                  _this.$router.push({
                    path: "/monitorRptIndexParent"
                  });
                }else{
                  if(_this.swiftRoleAbility == '0'){ //不允许修改执行角色(首次进入上报页面的用户不弹窗，默认为手卫生观察员之外的其他执行角色)
                    let arr = ['3']
                    localStorage.setItem('roleCode',arr)
                    _this.$router.push({
                      path: "/monitorRptIndexParent"
                    });
                    return
                  }
                  _this.isShowRoleSelect = true
                }
              }
            };
          } catch (err) { }
          try {
            uni.postMessage({
              data: {
                action: 'showIsAuth',
                data: 'jumpToMonitorRptIndex'
              }
            });
            window.webkit.messageHandlers.showIsAuth.postMessage("jumpToMonitorRptIndex");
          } catch (err) {
            window.gk.showIsAuth("jumpToMonitorRptIndex");
          }
        } else {
          this.handleJump()
        }
      },
      // 确定角色
      conFirmRole(val){
        if(val.length>0){
          this.isShowRoleSelect = false
          localStorage.setItem('roleCode',val.join())
          let params = {
            comId: this.currentComId,
            userId: this.currentUserId,
            data: {
              comId: this.currentComId,
              taskId: this.$route.query.taskId,
              userPost: val.join(), // 1-手卫生观察员，2-其他数据检测员 3-其他医务人员
              userName: this._userInfo.data.cnName?this._userInfo.data.cnName:this._userInfo.data.userName,
              userId: this.currentUserId
            }
          };
          this.$http.updateSwsReportingUser(params).then((res) => {
            if (res.code === 0) {
              this.$router.push({
                path: "/monitorRptIndexParent"
              });
            } else {
              this.$toast(res.msg);
            }
          });
        }else{
          Toast('请先选择角色')
        }
      },
      // 弹窗左侧按钮
      handleBtnLeft() {
        if (this.$route.query.source != 0) {
          this.isShowPopup = false
        }
      },
      // 弹窗右侧按钮
      handleBtnRight() {
        if (this.$route.query.source != 0) {
          this.goDownApp()
          // this.$router.push({ path: "/openApp" });
        }
      },
      // 跳转到手卫生观察员培训与测评
      handleToKnowledgeMeasurement(){
        if(this.$route.query.source == 0){
          if(this.isAuth==1){
            let  path = `${this._studyExamBase}/manager-intf/?#${this.knowledgePath}&userId=${this.currentUserId}&source=0&taskId=${this.$route.query.taskId}&batch=${this.$route.query.batch}`;  
            console.log(path,'去学习考试路径');
            location.href = path + (this._userInfo.data.uniHm == '1' ? '&uniHm=1' : '')
          }else{
            this.$toast('需等您提交的个人信息审核通过之后才能进行操作')
          }
          // this.$router.push({
          //   path: "/knowledgeMeasurement",
          //   query: {
          //     titleName: '手卫生观察员培训与测评',
          //     taskId:this.$route.query.taskId
          //   },
          // });
        }else{
          this.handleJump()
        }
        
      }
    },
  }
</script>
<style lang='scss' scoped>
  .handMonitorRrported {
    display: flex;
    flex-direction: column;
    height: 100vh;
    font-size: 16px;
    font-weight: 400;
    font-family: PingFangSC, PingFangSC-Regular;
    color: #333;
    .container {
      overflow: scroll;
      height: 100vh;
      .banner {
        height: 160px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .tab-content{
        border-radius: 10px 10px 0 0 ;
        margin-top: -15px;
        overflow: hidden;
      }
      .item-title {
        &:before {
          margin-right: 5px;
          content: '';
          display: inline-block;
          width: 4px;
          height: 18px;
          background: #26b4ff;
          border-radius: 2px;
        }
      }
      .item-title1{
        padding: 15px;
        // background-color: #f1f5ff;
      }
      .introduce {
        margin-bottom: 10px;
        padding-top: 25px;
        .video-box {
          padding: 15px 15px 11px 15px;
          width: 96%;
          margin: 0 auto;
          margin-bottom: 15px;
          background: #f7f8fa;
          border-radius: 10px;
          video {
            width: 100%;
            height: 100%;
          }
          img {
            width: 100%;
            height: 168px;
          }
          p {
            margin-top: 15px;
            text-align: center;
          }
        }
        .activity-background {
          padding: 15px 12px;
          background: #f1f5ff;
          .item-content {
            margin-top: 10px;
            padding: 12px;
            background: #ffffff;
            border-radius: 5px;
            .content-title {
              margin-bottom: 10px;
              font-size: 17px;
              font-family: PingFangSC, PingFangSC-Medium;
              font-weight: 500;
            }
            p {
              font-size: 15px;
              color: #666;
            }
          }
          .notice-file {
            margin: 10px 6px 0px;
            height: 40px;
            background: #ffffff;
            border-radius: 20px;
            span {
              color: #1c91ff;
              font-size: 16px;
            }
            img {
              width: 15px;
              height: 15px;
            }
          }
        }
        .earnings {
          padding: 15px 12px;
          background: #fff;
          h3 {
            font-size: 18px;
            font-family: SourceHanSansCN, SourceHanSansCN-Bold;
            font-weight: 700;
          }
          .earnings-heed {
            margin-top: 10px;
            img {
              margin-right: 10px;
              width: 30px;
              height: 30px;
            }
            p {
              padding: 15px 7px;
              color: #666666;
              font-size: 15px;
              text-align: center;
              font-family: SourceHanSansCN, SourceHanSansCN-Regular;
            }
          }
          .earnings-content {
            margin-bottom: 30px;
            .earnings-left {
              flex: 1;
              display: flex;
              flex-direction: column;
              p {
                font-size: 14px;
                font-family: SourceHanSansCN, SourceHanSansCN-Regular;
                color: #666666;
              }
              .p-right {
                text-align: right;
              }
            }
            .earnings-right {
              flex: 1;
              height: 130px;
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
        .list-content {
          width: 100%;
          padding: 15px 20px 5px;
          background: #f7f8fa;
          border-radius: 10px;

          li {
            margin-bottom: 10px;
            font-size: 14px;
            color: #666;
            &::before {
              margin-right: 8px;
              content: '';
              display: inline-block;
              width: 6px;
              height: 6px;
              background: #26b4ff;
              border-radius: 50%;
            }
          }
        }
        .data-safety {
          padding: 15px 12px 40px;
          background: #f1f5ff;
          .data-safety-content {
            margin-top: 10px;
            padding: 10px;
            background: #ffffff;
            border-radius: 5px;
            p {
              font-size: 15px;
              color: #666666;
            }
          }
        }
      }
      .tab-flow {
        padding: 10px 12px;
        .template-download {
          margin: 0px 6px 15px;
          height: 40px;
          background: #f7f8fa;
          border-radius: 20px;
          span {
            color: #1c91ff;
            font-size: 16px;
          }
          .download {
            margin-left: 8px;
            text-decoration: underline;
          }
        }
        .flow-item {
          .flow-title {
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 500;
            span {
              width: 22px;
              height: 22px;
              background: #26b4ff;
              border-radius: 50%;
              color: #fff;
            }
            h3 {
              font-size: 17px;
              margin-left: 13px;
            }
          }
          .flow-content-box {
            margin-left: 11px;
            padding: 15px 0px 15px 20px;
            border-left: 1px solid #eee;
            background-color: #fff;
            .flow-content {
              padding: 15px;
              background: #f7f8fa;
              color: #333;
              img {
                margin: 5px 8px 0px 0px;
                width: 14px;
                height: 14px;
              }
              .flow-content-item-time {
                margin-bottom: 15px;
                p{
                  font-size: 15px;
                }
              }
              .flow-content-item {
                display: flex;
                margin-left: 5px;
                .dot {
                  margin: 8px 13px 0px 0px;
                  width: 5px;
                  height: 5px;
                  background: #26b4ff;
                  border-radius: 50%;
                }
                p {
                  margin-bottom: 8px;
                  flex: 1;
                  font-size: 15px;
                }
              }
            }
          }
        }
      }
      .recommend {
        width: 92%;
        height: 524px;
        margin: 0px auto 50px;
        background: #f7f8fa;
        border-radius: 10px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .dalog-box {
        position: relative;
        width: 310px;
        background-color: #fff;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        font-size: 16px;
        border-radius: 10px;
        overflow: hidden;
        .dalog-content {
          padding: 24px;
          border-bottom: 1px solid #eee;
          .dalog-title {
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 500;
            color: #333333;
            margin-bottom: 10px;
            text-align: center;
          }
          p {
            font-size: 14px;
            color: #666;
          }
        }
        .btn-box {
          color: #26b4ff;
          .btn {
            flex: 1;
            padding: 12px 0px;
          }
          .btn-gray {
            color: #323233;
            border-right: 1px solid #eee;
          }
        }
        .close-dalog {
          position: absolute;
          top: 0px;
          right: 0px;
          padding: 10px;
          .icon-close {
            font-size: 18px;
          }
        }
      }
    }
    .footer {
      padding: 10px 15px;
      background-color: #fff;
      .btn {
        height: 38px;
        border-radius: 20px;
      }
      .progressAndStatistics {
        flex: 5;
        border: 1px solid #1c91ff;
        color: #1c91ff;
      }
      .join-reported {
        margin-left: 10px;
        flex: 3;
        background-color: #1c91ff;
        color: #fff;
      }
    }
  }
</style>